import colors from 'assets/styles/colors';
import { pxToRem } from 'assets/styles/convertors';
import UI from 'constants/ui';
import styled from 'styled-components';

export const PageHeaderWrapper = styled.div`
  background: var(--color-black900);
  padding: 1.7rem 0;
  margin-bottom: 2rem;
  border-bottom: ${pxToRem(1)} solid ${colors.gray700};
`;

export const PageName = styled.h1<{ $capitalize?: boolean; $truncateText?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${UI.text.h2};
  font-weight: 700;
  line-height: 130%;
  flex: 1;

  ${({ $capitalize }) =>
    $capitalize &&
    `
    text-transform: capitalize;
  `};

  ${({ $truncateText }) =>
    $truncateText &&
    `
      overflow: hidden;
      text-overflow: ellipsis;
      pointer-events: none;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      -webkit-box-align: start;
  `}
`;

export const BackButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${UI.radius.sm};
  background-color: ${colors.gray800};
  color: white;

  @media (hover: hover) {
    &:hover {
      background-color: ${colors.gray600};
    }
  }

  width: ${pxToRem(40)};
  height: ${pxToRem(40)};
  padding: 0px;
`;
